var map = {
	"./Back ChevronNormal.png": "41c2",
	"./Chevron-right.png": "7f31",
	"./Chevron-right@2x.png": "056c",
	"./Chevron-right@3x.png": "eef5",
	"./Ellipse20.png": "59a8",
	"./Ellipse20@2x.png": "9fe6",
	"./Group 40.png": "a6d4",
	"./Group 40@2x.png": "7c34",
	"./Line143@2x.png": "ea2f",
	"./Path -1.png": "3c74",
	"./Path -1@2x.png": "b709",
	"./Rectangle 37@2x.png": "0c7e",
	"./ShapeNormal.png": "b226",
	"./ShapeNormal_1.png": "b16d",
	"./WaterGuru-Logo-Blue.svg": "3a9a",
	"./WaterGuru-Logo.svg": "db38",
	"./accordion-plusminus.png": "d51d",
	"./android-chrome-192x192.png": "8b7c",
	"./android-chrome-256x256.png": "0966",
	"./apple-touch-icon.png": "f76b",
	"./battImgBar0.png": "8afa",
	"./battImgBar0@2x.png": "8c60",
	"./battImgBar0@3x.png": "47b0",
	"./battImgBar1.png": "e5b8",
	"./battImgBar1@2x.png": "9807",
	"./battImgBar1@3x.png": "0845",
	"./battImgBar2.png": "714e",
	"./battImgBar2@2x.png": "521e",
	"./battImgBar2@3x.png": "2e7c",
	"./battImgBar3.png": "ca7e",
	"./battImgBar3@2x.png": "ca68",
	"./battImgBar3@3x.png": "781d",
	"./battImgBar4.png": "e664",
	"./battImgBar4@2x.png": "4090",
	"./battImgBar4@3x.png": "65cd",
	"./battery.svg": "2fbc",
	"./bg-support-hero.jpg": "bd7a",
	"./cart.png": "ec17",
	"./close-button-black.png": "0b83",
	"./close.png": "d991",
	"./datatable-row-openclose.png": "5c42",
	"./favicon-16x16.png": "d1d3",
	"./favicon-32x32.png": "f245",
	"./footer-divider.png": "f926",
	"./gear-web-app-gray.png": "e187",
	"./gear-web-app-gray@2x.png": "1115",
	"./gear-web-app-gray@3x.png": "f936",
	"./headerBg.png": "362b",
	"./icon-facebook.png": "af48",
	"./imageNormal.png": "f1a8",
	"./indicator/Blue-Center.png": "8855",
	"./indicator/Blue-Center@2x.png": "17e2",
	"./indicator/Blue-L-1.png": "367b",
	"./indicator/Blue-L-1@2x.png": "8830",
	"./indicator/Blue-L-2.png": "b6d0",
	"./indicator/Blue-L-2@2x.png": "cf7b",
	"./indicator/Blue-L-3.png": "d738",
	"./indicator/Blue-L-3@2x.png": "9eff",
	"./indicator/Blue-R-1.png": "7559",
	"./indicator/Blue-R-1@2x.png": "ae75",
	"./indicator/Blue-R-2.png": "d5d1",
	"./indicator/Blue-R-2@2x.png": "a77a",
	"./indicator/Blue-R-3.png": "be84",
	"./indicator/Blue-R-3@2x.png": "56cf",
	"./indicator/Red-L-1.png": "8e6f",
	"./indicator/Red-L-1@2x.png": "1e59",
	"./indicator/Red-L-2.png": "d080",
	"./indicator/Red-L-2@2x.png": "121f",
	"./indicator/Red-L-3.png": "804e",
	"./indicator/Red-L-3@2x.png": "4738",
	"./indicator/Red-R-1.png": "0002",
	"./indicator/Red-R-1@2x.png": "2e61",
	"./indicator/Red-R-2.png": "91a3",
	"./indicator/Red-R-2@2x.png": "63a5",
	"./indicator/Red-R-3.png": "8207",
	"./indicator/Red-R-3@2x.png": "a125",
	"./indicator/Yellow-L-1.png": "2c44",
	"./indicator/Yellow-L-1@2x.png": "4e83",
	"./indicator/Yellow-L-2.png": "6cfd",
	"./indicator/Yellow-L-2@2x.png": "f58a",
	"./indicator/Yellow-L-3.png": "9b6b",
	"./indicator/Yellow-L-3@2x.png": "0871",
	"./indicator/Yellow-R-1.png": "063b",
	"./indicator/Yellow-R-1@2x.png": "1858",
	"./indicator/Yellow-R-2.png": "ce33",
	"./indicator/Yellow-R-2@2x.png": "d356",
	"./indicator/Yellow-R-3.png": "2c22",
	"./indicator/Yellow-R-3@2x.png": "00f9",
	"./instructions/Alt_fill_lines.png": "3b64",
	"./instructions/Battery.png": "93bf",
	"./instructions/Battery_Replacement.png": "af29",
	"./instructions/Cassette_Replacement.png": "55c9",
	"./instructions/Emptying.png": "50a7",
	"./instructions/Emptying_Fluid.png": "a5c0",
	"./instructions/Emptying_the_Powder.png": "9658",
	"./instructions/Emptying_the_skimmer.png": "dad3",
	"./instructions/Filling_the_Tube.png": "1c51",
	"./instructions/Follow_the_Instructions.png": "9d3c",
	"./instructions/Follow_the_Instructions_on_the_Bottle.png": "e093",
	"./instructions/If_there's_liquid_in_the_tube_due_to_overfilling....png": "ec35",
	"./instructions/Opening_the_Tube.png": "f213",
	"./instructions/Pouring_the_liquid.png": "c056",
	"./instructions/Prepare_the_Area.png": "efce",
	"./instructions/Preparing_the_Area.png": "1ef0",
	"./instructions/Pump_Speed.png": "0ffd",
	"./instructions/Sensor_Height.png": "9a23",
	"./instructions/Skimmer_Size.png": "61e1",
	"./instructions/Video.png": "da23",
	"./instructions/Water_Test.png": "851a",
	"./instructions/WiFi.png": "7f20",
	"./instructions/WiFi_Availability.png": "4f24",
	"./log-out-active.png": "98a0",
	"./log-out-active@2x.png": "8b1d",
	"./log-out.png": "948c",
	"./log-out@2x.png": "44f2",
	"./logo.png": "9d64",
	"./mstile-150x150.png": "7d38",
	"./my-pools-active.png": "d6b2",
	"./my-pools-active@2x.png": "7d94",
	"./my-pools-blue.png": "ac9f",
	"./my-pools-blue@2x.png": "b426",
	"./my-pools-night.png": "d38f",
	"./my-pools-night@2x.png": "4186",
	"./my-pools-red.png": "e3a7",
	"./my-pools-red@2x.png": "5b5b",
	"./my-pools.png": "1812",
	"./my-pools@2x.png": "6243",
	"./navMenu.png": "ab11",
	"./play-button.png": "edfd",
	"./plusminus.png": "d7ff",
	"./pool.png": "f080",
	"./pool.svg": "f963",
	"./profile-active.png": "0af4",
	"./profile-active@2x.png": "5bf8",
	"./profile.png": "b31e",
	"./profile@2x.png": "18a7",
	"./remove-icon-small.png": "afba",
	"./safari-pinned-tab.svg": "3720",
	"./store-active.png": "7a3b",
	"./store-active@2x.png": "01ff",
	"./store.png": "f606",
	"./store@2x.png": "a12b",
	"./support-active.png": "5c2c",
	"./support-active@2x.png": "f3a7",
	"./support.png": "a884",
	"./support@2x.png": "becc",
	"./temp.png": "2279",
	"./temp@2x.png": "9853",
	"./temp@3x.png": "f13f",
	"./test.png": "9165",
	"./thermometer.svg": "823b",
	"./user.png": "ba97",
	"./view-graphs.png": "d596",
	"./view-graphs@2x.png": "d665",
	"./view-graphs@3x.png": "f800"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";